<template>
  <div
    v-if="submenu.menuItems.length"
    class="box box-menu is-paddingless"
  >
    <ul class="menu-list">
      <li
        v-for="(submenuItem, index) in submenu.menuItems"
        :key="'sub_'+index"
      >
        <a
          @click="setView(submenuItem)"
          :class="{ 'is-active': mSelectedView === submenuItem.view }"
        >
          {{submenuItem.label}}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PageSubmenu',

  props: {
    value: {
      type: [Number, String],
      default: ''
    }
  },

  inject: {
    submenu: {
      type: Object,
      default: function() {
        return {
          menuItems: []
        }
      }
    },
    selectedView: {
      type: String,
      default: ''
    },
    callbackSelectSubmenu: {
      type: Function,
      default: () => { }
    }
  },

  data() {
    return {
      mSelectedView: this.selectedView
    }
  },

  methods: {
    setView(_selectedView) {
      this.mSelectedView = _selectedView.view
      this.callbackSelectSubmenu(_selectedView)
    },

    isSelected(pageSubmenu) {
      if (typeof pageSubmenu.view !== 'undefined') {
        return this.selectedView === pageSubmenu.view
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>